import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Chip,
  Grid,
  Tooltip,
  Typography,
  TextField,
  ListItem,
  Button,
  ListItemText,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import InfoIcon from "@mui/icons-material/Info";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import paymentportalservice from "../../services/paymentportalservice";

function Brand({ totalBrand, isSuperUser }) {
  const [brand, setBrand] = useState([]);
  const [postBrand, setPostBrand] = useState([]);
  const [newBrandName, setNewBrandName] = useState("");

  const fetchBrands = async () => {
    try {
      const data = await paymentportalservice.FetchBrandsData();
      // console.log("data length of brands.......", data.length);
      // Handle different response structures
      let brandsArray = [];
      if (Array.isArray(data)) {
        brandsArray = data;
      } else if (data && data.data && Array.isArray(data.data)) {
        brandsArray = data.data;
      } else if (data && data.brands && Array.isArray(data.brands)) {
        brandsArray = data.brands;
      } else if (data && typeof data === "object") {
        brandsArray =
          Object.values(data).find((val) => Array.isArray(val)) || [];
      }

      setBrand(brandsArray);
    } catch (error) {
      console.log("Error", error);
      setBrand([]);
    }
  };

  const handleAddBrand = async () => {
    if (!newBrandName.trim()) {
      console.log("Brand name is required");
      return;
    }

    try {
      const response = await paymentportalservice.PostBrands({ name: newBrandName });
      console.log(response);
      setNewBrandName("");
      setState({ ...state, right: false });
      await fetchBrands(); // Refresh the list
    } catch (error) {
      console.log('error in posting brands', error);
    }
  }

  useEffect(() => {
    fetchBrands();
    // postBrands();
  }, []);

  const [open, setOpen] = useState(false);
  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const [viewState, setViewState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const handleShowCampaignForm = () => {
    setOpen(true);
  };

  const toggleDrawer = (anchor1, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor1]: open });
  };

  const toggleViewDrawer = (anchor2, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setViewState({ ...viewState, [anchor2]: open });
  };

  const handleClose = () => setOpen(false);

  const brandForm = (anchor) => (
    <>
      <Box sx={{ paddingX: 3, paddingTop: 3 }} role="presentation">
        <Typography variant="h6" textAlign={"center"} fontWeight={"bold"}>
          Add Brand
        </Typography>
        <List>
          <ListItem disablePadding>
            <TextField
              id="outlined-basic"
              label="Brand*"
              variant="outlined"
              sx={{ width: 350 }}
              value={newBrandName}
              onChange={(e) => setNewBrandName(e.target.value)}
            />
          </ListItem>
        </List>
        <Box sx={{ marginTop: 2, textAlign: "center" }} >
          <Button onClick={handleAddBrand} variant="outlined">Add</Button>
        </Box>
      </Box>
    </>
  );

  const brandView = (anchor2) => (
    <>
      <Box sx={{ paddingX: 3, paddingTop: 3 }} role="presentation">
        {/* {brand && brand.length > 0 ? (
          <List >
            {brand.map((brandItem, index) => (
              <List key={brandItem._id || index} >
                <ListItem style={{ borderBottom: '1px solid black' }}>
                  <ListItemText>
                    {brandItem.name ||
                      brandItem.brand_name ||
                      `Brand ${index + 1}`}
                  </ListItemText>
                </ListItem>
              </List>
            ))}
          </List>
        ) : (
          <List>
            <ListItem>
              <ListItemText>No brands found</ListItemText>
            </ListItem>
          </List>
        )} */}
        <Typography variant="h6">Brands ({brand.length})</Typography>
        {brand && brand.length > 0 ? (
          <List>
            {[...brand].reverse().map((brandItem, index) => (
              <List key={brandItem._id || index}>
                <ListItem style={{ borderBottom: "1px solid  #D3D3D3" }}>
                  <ListItemText>
                    {brandItem.name ||
                      brandItem.brand_name ||
                      `Brand ${index + 1}`}
                  </ListItemText>
                </ListItem>
              </List>
            ))}
          </List>
        ) : (
          <List>
            <ListItem>
              <ListItemText>No brands found</ListItemText>
            </ListItem>
          </List>
        )}
      </Box>
    </>
  );

  const anchor1 = "right";
  const anchor2 = "right";

  return (
    <>
      <SwipeableDrawer
        anchor={anchor1}
        open={state[anchor1]}
        onClose={toggleDrawer(anchor1, false)}
        onOpen={toggleDrawer(anchor1, true)}
      >
        {brandForm(anchor1)}
      </SwipeableDrawer>

      <SwipeableDrawer
        anchor={anchor2}
        open={viewState[anchor2]}
        onClose={toggleViewDrawer(anchor2, false)}
        onOpen={toggleViewDrawer(anchor2, true)}
      >
        {brandView(anchor2)}
      </SwipeableDrawer>

      <Grid item xs={4}>
        <Card sx={{ padding: 2 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <CardContent
              sx={{ padding: 1, cursor: "pointer" }}
              onClick={toggleViewDrawer(anchor2, true)}
            >
              <Typography component="div" variant="h5">
                <Chip
                  label={totalBrand || (brand ? brand.length : 0)}
                  size="small"
                  variant="filled"
                  sx={{ backgroundColor: "#F9B572", color: "#ffffff" }}
                />
              </Typography>
              <Typography
                variant="subtitle1"
                color="text.secondary"
                component="div"
                fontWeight={"bold"}
              >
                BRANDS
              </Typography>
            </CardContent>
            <Box sx={{ alignSelf: "center" }}>
              <Tooltip title="Add Brand" onClick={toggleDrawer(anchor1, true)}>
                <AddCircleIcon sx={{ cursor: "pointer", color: "#FFD206" }} />
              </Tooltip>
              <Tooltip
                title="View Brands"
                onClick={toggleViewDrawer(anchor2, true)}
              >
                <InfoIcon sx={{ cursor: "pointer", color: "#0AC380" }} />
              </Tooltip>
            </Box>
          </Box>
        </Card>
      </Grid>
    </>
  );
}

export default Brand;

// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Card,
//   CardContent,
//   Chip,
//   Grid,
//   Tooltip,
//   Typography,
//   TextField,
//   ListItem,
//   Button,
//   ListItemText,
//   Autocomplete,
// } from "@mui/material";
// import AddCircleIcon from "@mui/icons-material/AddCircle";
// import InfoIcon from "@mui/icons-material/Info";
// import SwipeableDrawer from "@mui/material/SwipeableDrawer";
// import List from "@mui/material/List";
// import Divider from "@mui/material/Divider";
// import paymentportalservice from "../../services/paymentportalservice";

// function Brand({ totalBrand }) {
//   const [brand, setBrand] = useState([]);
//   const [selectedBrand, setSelectedBrand] = useState(null);

//   const fetchBrands = async () => {
//     try {
//       const data = await paymentportalservice.FetchBrandsData();
//       console.log("data length of brands.......", data.length);
//       // Handle different response structures
//       let brandsArray = [];
//       if (Array.isArray(data)) {
//         brandsArray = data;
//       } else if (data && data.data && Array.isArray(data.data)) {
//         brandsArray = data.data;
//       } else if (data && data.brands && Array.isArray(data.brands)) {
//         brandsArray = data.brands;
//       } else if (data && typeof data === "object") {
//         brandsArray =
//           Object.values(data).find((val) => Array.isArray(val)) || [];
//       }

//       setBrand(brandsArray);
//     } catch (error) {
//       console.log("Error", error);
//       setBrand([]);
//     }
//   };

//   useEffect(() => {
//     fetchBrands();
//   }, []);

//   const [open, setOpen] = useState(false);
//   const [state, setState] = useState({
//     top: false,
//     left: false,
//     bottom: false,
//     right: false,
//   });

//   const [viewState, setViewState] = useState({
//     top: false,
//     left: false,
//     bottom: false,
//     right: false,
//   });

//   const handleShowCampaignForm = () => {
//     setOpen(true);
//   };

//   const toggleDrawer = (anchor1, open) => (event) => {
//     if (
//       event &&
//       event.type === "keydown" &&
//       (event.key === "Tab" || event.key === "Shift")
//     ) {
//       return;
//     }

//     setState({ ...state, [anchor1]: open });
//   };

//   const toggleViewDrawer = (anchor2, open) => (event) => {
//     if (
//       event &&
//       event.type === "keydown" &&
//       (event.key === "Tab" || event.key === "Shift")
//     ) {
//       return;
//     }

//     setViewState({ ...viewState, [anchor2]: open });
//   };

//   const handleClose = () => setOpen(false);

//   const brandForm = (anchor) => (
//     <>
//       <Box sx={{ paddingX: 3, paddingTop: 3 }} role="presentation">
//         <Typography variant="h6" textAlign={"center"} fontWeight={"bold"}>
//           Add Brand
//         </Typography>
//         <List>
//           <ListItem disablePadding>
//             <TextField
//               id="outlined-basic"
//               label="Brand*"
//               variant="outlined"
//               sx={{ width: 350 }}
//             />
//           </ListItem>
//         </List>
//         <Box sx={{ marginTop: 2, textAlign: "center" }}>
//           <Button variant="outlined">Add</Button>
//         </Box>
//       </Box>
//     </>
//   );

//   const brandView = (anchor2) => (
//     <>
//       <Box sx={{ paddingX: 3, paddingTop: 3 }} role="presentation">
//         <Autocomplete
//           options={brand}
//           getOptionLabel={(option) => option?.name || option?.brand_name || ""}
//           value={selectedBrand}
//           onChange={(event, newValue) => {
//             setSelectedBrand(newValue);
//           }}
//           onSe
//           renderInput={(params) => (
//             <TextField
//               {...params}
//               label="Search or select brand..."
//               variant="outlined"
//             />
//           )}
//           isOptionEqualToValue={(option, value) => option?._id === value?._id}
//           sx={{ mb: 2 }}
//         />
//         <Divider sx={{ marginY: 1 }} />
//         <Typography variant="subtitle2" sx={{ px: 2, py: 1, fontWeight: "bold" }}>
//           All Brands ({brand.length})
//         </Typography>
//         {brand && brand.length > 0 ? (
//           <List>
//             {brand.map((brandItem, index) => (
//               <List key={brandItem._id || index}>
//                 <ListItem>
//                   <ListItemText>
//                     {brandItem.name ||
//                       brandItem.brand_name ||
//                       `Brand ${index + 1}`}
//                   </ListItemText>
//                 </ListItem>
//               </List>
//             ))}
//           </List>
//         ) : (
//           <List>
//             <ListItem>
//               <ListItemText>No brands found</ListItemText>
//             </ListItem>
//           </List>
//         )}
//       </Box>
//     </>
//   );

//   const anchor1 = "right";
//   const anchor2 = "right";

//   return (
//     <>
//       <SwipeableDrawer
//         anchor={anchor1}
//         open={state[anchor1]}
//         onClose={toggleDrawer(anchor1, false)}
//         onOpen={toggleDrawer(anchor1, true)}
//       >
//         {brandForm(anchor1)}
//       </SwipeableDrawer>

//       <SwipeableDrawer
//         anchor={anchor2}
//         open={viewState[anchor2]}
//         onClose={toggleViewDrawer(anchor2, false)}
//         onOpen={toggleViewDrawer(anchor2, true)}
//       >
//         {brandView(anchor2)}
//       </SwipeableDrawer>

//       <Grid item xs={4}>
//         <Card sx={{ padding: 2 }}>
//           <Box sx={{ display: "flex", justifyContent: "space-between" }}>
//             <CardContent sx={{ padding: 1 }}>
//               <Typography component="div" variant="h5">
//                 <Chip
//                   label={totalBrand || (brand ? brand.length : 0)}
//                   size="small"
//                   variant="filled"
//                   sx={{ backgroundColor: "#F9B572", color: "#ffffff" }}
//                 />
//               </Typography>
//               <Typography
//                 variant="subtitle1"
//                 color="text.secondary"
//                 component="div"
//                 fontWeight={"bold"}
//               >
//                 BRANDS
//               </Typography>
//             </CardContent>
//             <Box sx={{ alignSelf: "center" }}>
//               <Tooltip title="Add Brand" onClick={toggleDrawer(anchor1, true)}>
//                 <AddCircleIcon sx={{ cursor: "pointer", color: "#FFD206" }} />
//               </Tooltip>
//               <Tooltip
//                 title="View Brands"
//                 onClick={toggleViewDrawer(anchor2, true)}
//               >
//                 <InfoIcon sx={{ cursor: "pointer", color: "#0AC380" }} />
//               </Tooltip>
//             </Box>
//           </Box>
//         </Card>
//       </Grid>
//     </>
//   );
// }

// export default Brand;
